import React from 'react'
import { useFieldArray } from 'react-hook-form'
import { Content, Label } from './styles'
import { Row } from '../../../../../components/commons'
import Input from '../../../../../components/Input'
import { ButtonRound } from '../../../../../components/Header/styles'
import { FaUpload, FaXmark } from 'react-icons/fa6'
import useToast from '../../../../../hooks/useToast'
import SelectInput from '../../../../../components/Input/SelectInput'

export interface MetaDataInputProps {
  control: any
  label?: string
  error?: any
  documentTypeInfo?: any
  setError: any
  setLines: any
  lines: any
  getValues: any
  disabled?: boolean
  name: string
}

const MetaDataInput: React.FunctionComponent<MetaDataInputProps> = ({
  control,
  setLines,
  label,
  documentTypeInfo,
  error,
  name,
}) => {
  const inputRef = React.useRef<any>(null)

  const toast = useToast()

  const { fields, append, update, remove } = useFieldArray({
    control,
    name: name,
  })

  const handleChange = (e: any) => {
    if (e.target.files.length) {
      e.persist()

      let file = e.target.files[0]
      const regex = /(?:[^,"]+|"[^"]*")+/g

      let fr = new FileReader()
      fr.onload = function () {
        let fileValue: any = fr.result
        remove()

        const convertToArray = fileValue.split('\n')

        const lines: any = []
        let match

        convertToArray.map((baseString: any) => {
          const valores: any = []
          while ((match = regex.exec(baseString)) !== null) {
            valores.push(match[0].replace(/"/g, ''))
          }

          lines.push(valores)
        })

        setLines(lines)

        if (lines.length <= 0) return toast.errorToast('Nenhum documento encontrado!')

        let firstLine = lines[0]

        firstLine.map((line: any) =>
          append({
            value: line.replace(/\r\n/g, ''),
            name: '',
          }),
        )
      }

      fr.readAsText(file, 'ISO-8859-1')
    }
  }

  const handleOpen = () => {
    if (!documentTypeInfo) return toast.errorToast('Selecione um Tipo de documento')

    inputRef.current && inputRef.current.click()
  }

  const removeValue = (index: number) => {
    update(index, { name: undefined, value: undefined })
  }

  return (
    <Content>
      {label && (
        <Row justify='center' gap={10}>
          <Label>{label}</Label>
          <input id='file' ref={inputRef} onChange={handleChange} type='file' hidden name='file' />
          <ButtonRound onClick={() => handleOpen()}>
            <FaUpload color='white' size={15} />
          </ButtonRound>
        </Row>
      )}

      {fields.map((cp: any, index: number) => {
        let errorValue = error && typeof error[index] !== 'undefined' ? error[index].name : null

        if (cp?.value === undefined) return <></>
        return (
          <div key={cp.value}>
            <Label>Coluna #{index + 1}</Label>

            <Row gap={10} align='center' justify='center'>
              <SelectInput
                options={documentTypeInfo.metadata.map((el: any) => ({
                  label: el.name,
                  value: el.name,
                }))}
                menuPosition={'fixed'}
                control={control}
                name={`${name}.${index}.name`}
                error={errorValue}
              />
              <Input
                control={control}
                disabled
                name={`${name}.${index}.value`}
                error={error}
                type='text'
              />
              <ButtonRound
                style={{ width: 30, height: 30, minWidth: 30, minHeight: 30 }}
                onClick={() => removeValue(index)}
              >
                <FaXmark color='white' size={25} />
              </ButtonRound>
            </Row>
          </div>
        )
      })}
    </Content>
  )
}

export default MetaDataInput
